/* eslint-disable max-lines */
import { Translate } from "../../../../../../../constant/Translate"
import {
  ColumnType,
  UseTableConfigType,
} from "../../../../../../../_webui/layout/components/Table/models"
import { SchedulesBatchDeleteDataType } from "../../../../models/batchDelete/data"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { combineWithBracket } from "../../../../../../../utils/combineWithBracket"
import { getValueOrUndecided } from "../../../../../../../utils/getValueOrUndecided"

const {
  TEXT_T002,
  TEXT_T192,
  TEXT_T199,
  TEXT_T200,
  TEXT_T215,
  TEXT_T219,
  TEXT_T224,
  TEXT_T234,
  TEXT_T235,
  TEXT_T236,
  TEXT_T405,
  TEXT_T439,
  TEXT_T686,
} = Translate

export const useTableConfig =
  (): UseTableConfigType<SchedulesBatchDeleteDataType> => {
    const columns: ColumnType<SchedulesBatchDeleteDataType>[] = [
      {
        dataIndex: "userId",
        sorter: (a, b) => a.userId.localeCompare(b.userId),
        title: TEXT_T002,
        width: 250,
      },
      {
        dataIndex: "fullName",
        sorter: (a, b) => a.fullName.localeCompare(b.fullName),
        title: TEXT_T192,
        width: 130,
      },
      {
        dataIndex: "travelScheduleId",
        sorter: (a, b) => a.travelScheduleId.localeCompare(b.travelScheduleId),
        title: TEXT_T224,
        width: 170,
      },
      {
        dataIndex: "travelPurposeName",
        sorter: (a, b) =>
          a.travelPurposeName.localeCompare(b.travelPurposeName),
        title: TEXT_T215,
        width: getValueByLanguage(150, 170),
      },
      {
        dataIndex: "projectNameJp",
        sorter: (a, b) => a.projectNameJp.localeCompare(b.projectNameJp),
        title: TEXT_T199,
        width: 370,
      },
      {
        dataIndex: "projectNameEn",
        sorter: (a, b) => a.projectNameEn.localeCompare(b.projectNameEn),
        title: TEXT_T200,
        width: 370,
      },
      {
        dataIndex: "bumonName",
        sorter: (a, b) => a.bumonName.localeCompare(b.bumonName),
        title: TEXT_T234,
        width: 200,
      },
      {
        dataIndex: "mainPersonName",
        sorter: (a, b) => a.mainPersonName.localeCompare(b.mainPersonName),
        title: TEXT_T235,
        width: 210,
      },
      {
        dataIndex: "notificationPersonAddress",
        render: (_, data) =>
          combineWithBracket(
            data.notificationPersonAddressText,
            data.notificationPersonAddressName,
          ),
        sorter: (a, b) =>
          a.notificationPersonAddressText.localeCompare(
            b.notificationPersonAddressText,
          ),
        title: TEXT_T686,
        width: 250,
      },
      {
        dataIndex: "locationToSendMailName",
        render: (value) => getValueOrUndecided(value),
        sorter: (a, b) =>
          a.locationToSendMailName.localeCompare(b.locationToSendMailName),
        title: TEXT_T219,
        width: 210,
      },
      {
        dataIndex: "locationPersonName",
        sorter: (a, b) =>
          a.locationPersonName.localeCompare(b.locationPersonName),
        title: TEXT_T236,
        width: 210,
      },
      {
        dataIndex: "dispatchStartDate",
        sorter: (a, b) =>
          a.dispatchStartDate.localeCompare(b.dispatchStartDate),
        title: TEXT_T405,
        width: 170,
      },
      {
        dataIndex: "dispatchEndDate",
        sorter: (a, b) => a.dispatchEndDate.localeCompare(b.dispatchEndDate),
        title: TEXT_T439,
        width: 170,
      },
    ]
    return {
      columns,
    }
  }
